import { RouteItem } from '@eastcoal/router/types/route'

import { SEARCH_PAGE_PATH } from './constants/path'

import { SearchPage } from './index'

export const searchRoute: RouteItem = {
  title: '搜索页',
  path: SEARCH_PAGE_PATH,
  element: <SearchPage />
}
